import Env from "./env"

export default Env

export const getEnv = <T>(envName: string): T => Env.getEnv(envName)

export const isDevelopment = () => {
  return getEnv("NODE_ENV") === "development"
}
